interface LeasingPropertiesBase {
	resourceLeasingEnabled?: boolean;
}

export function isResourceLeaseLaunchEnabled(
	leasingProperties?: LeasingPropertiesBase
): boolean {
	const resourceLeasingEnabled = leasingProperties?.resourceLeasingEnabled;

	if (typeof resourceLeasingEnabled === 'string') {
		return (resourceLeasingEnabled as string).toLowerCase() === 'true';
	}

	return resourceLeasingEnabled === true;
}
